import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { TeiHubLinkAllGroupsModel } from "features/hublink/core/domain/tei-hub-link-group.model";
import {
  GetTeiHubLinkAllGroupsResponse,
  GetTeiHubLinkAllGroupsRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkAllGroups {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkAllGroups;
  message: string;
  data: Array<TeiHubLinkAllGroupsModel> | undefined;
}

const initialState: InitialState = {
  status: TeiHubLinkAllGroups.initial,
  message: "",
  data: undefined,
};

export const teiHubLinkAllGroups = createAsyncThunk(
  "teiHubLinkAllGroups",
  async (_, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkAllGroupsResponse =
        await GetTeiHubLinkAllGroupsRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkAllGroupsSlice = createSlice({
  name: "teiHubLinkAllGroups",
  initialState,
  reducers: {
    resetTeiHubLinkAllGroups: (state) => {
      state.status = TeiHubLinkAllGroups.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkAllGroups.pending, (state) => {
        state.status = TeiHubLinkAllGroups.inProgress;
      })
      .addCase(teiHubLinkAllGroups.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = TeiHubLinkAllGroups.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(teiHubLinkAllGroups.rejected, (state, action) => {
        state.status = TeiHubLinkAllGroups.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectTeiHubLinkAllGroups = (state: RootState) =>
  state.teiHubLinkAllGroups;

export const { resetTeiHubLinkAllGroups } = teiHubLinkAllGroupsSlice.actions;
export default teiHubLinkAllGroupsSlice.reducer;
